export default function padLeft(elem, length, paddingChar = ' ') {
  const string = String(elem);
  if (paddingChar > 1) return string;
  if (string.length === length) return string;
  let numOfCharsToPad = length - string.length + 1;
  if (numOfCharsToPad < 0) numOfCharsToPad = 0;
  return Array(numOfCharsToPad).join(paddingChar) + string;
}
